const moment = require("moment");
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withRefluxStore } from "../../Stores";
import { withRouter } from "react-router-dom";
import { Button as BtnPrimary } from "@talentbait/shared-components";
import { Store__System } from "@talentbait/shared-components";
import JobsStore from "./JobsStore";
import { ActionsJobs } from "../../Actions/ActionsJobs/ActionsJobs";
import {
  ADMIN_ORGANIZATIONS,
  ORGAS_WITH_JOBS_PERMISSION,
  CUSTOM_FIELDS_ORGANIZATIONS
} from "./Jobs.contants";
import {
  onCreateCampaignBasedOnJob,
  onFetchAndSaveJobs,
  onOpenCampaignBasedOnJob
} from "./handlers/index";
import * as SC from "./Jobs.styled";

const truncateText = (text, maxLength = 400) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + "...";
};

const Jobs = ({ userProfile, jobs, loading, campaignLoadingId }) => {
  const { t } = useTranslation();
  const hasPermission = ORGAS_WITH_JOBS_PERMISSION.includes(userProfile?.organizationId);
  const isAdmin = ADMIN_ORGANIZATIONS.includes(userProfile?.organizationId);
  const hasCustomFields = CUSTOM_FIELDS_ORGANIZATIONS.includes(userProfile?.organizationId);

  useEffect(() => {
    if (!hasPermission) return;
    ActionsJobs.getJobs(userProfile?.organizationId);
  }, [hasPermission, userProfile?.organizationId]);

  if (!hasPermission) {
    return (
      <SC.NoPermissionContainer>
        <SC.NoPermissionText>
          {t("You do not have permission to view this page.")}
        </SC.NoPermissionText>
        <SC.NoPermissionText>
          {t("Please contact your administrator if you believe this is an error.")}
        </SC.NoPermissionText>
      </SC.NoPermissionContainer>
    );
  }

  if (loading) {
    return (
      <SC.JobsContainer>
        <SC.LoadingContainer>
          <SC.Loader />
          <p>{t("Loading...")}</p>
        </SC.LoadingContainer>
      </SC.JobsContainer>
    );
  }

  return (
    <SC.JobsContainer>
      <SC.Header>
        <SC.Title>
          {t("Profile Jobs")} {jobs.length > 0 && `(${jobs.length})`}
        </SC.Title>
        <SC.ButtonContainer>
          {!hasCustomFields && (
            <BtnPrimary onClick={() => onFetchAndSaveJobs(userProfile?.organizationId)}>
              {t("Get Jobs")}
            </BtnPrimary>
          )}
        </SC.ButtonContainer>
      </SC.Header>

      <SC.TableContainer>
        <SC.Table>
          <thead>
            <tr>
              {hasCustomFields ? (
                <>
                  <th>{t("Job Title")}</th>
                  <th>{t("Job Posting URL")}</th>
                  <th>{t("Imported Date")}</th>
                  <th>{t("Locations")}</th>
                  <th>{t("Channels")}</th>
                  <th>{t("Employment Type")}</th>
                  <th>{t("Introduction")}</th>
                </>
              ) : (
                <>
                  {isAdmin && <th>{t("Job ID")}</th>}
                  <th>{t("Job Title")}</th>
                  <th>{t("Created Date")}</th>
                  <th>{t("Company")}</th>
                  <th>{t("Job Posting URL")}</th>
                  <th>{t("Locations")}</th>
                  <th>{t("Channels")}</th>
                  <th>{t("Recommended Budget")}</th>
                  <th>{t("Status")}</th>
                  <th>{t("Actions")}</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {jobs.length > 0 ? (
              jobs.map((job) => (
                <tr key={job.id}>
                  {hasCustomFields ? (
                    <>
                      <td>
                        <SC.JobTitle>{job.jobTitle}</SC.JobTitle>
                      </td>
                      <td>
                        <SC.JobUrl target="_blank" href={job.jobPostingUrl} rel="noreferrer">
                          {job.jobPostingUrl}
                        </SC.JobUrl>
                      </td>
                      <td>
                        <SC.DateText>
                          {job.createdDate ? moment(job.createdDate).format("DD.MM.YYYY") : "N/A"}
                        </SC.DateText>
                      </td>
                      <td>
                        <SC.LocationText>{job.locations.join(", ")}</SC.LocationText>
                      </td>
                      <td>
                        {job?.channels?.length > 0 ? (
                          <SC.ChannelsList>
                            {job.channels.map((channel, index) => (
                              <SC.ChannelItem key={index}>{channel}</SC.ChannelItem>
                            ))}
                          </SC.ChannelsList>
                        ) : (
                          <SC.NotDefinedText>Not defined</SC.NotDefinedText>
                        )}
                      </td>
                      {job?.employmentType?.length > 0 ? (
                        <td>
                          <SC.ChannelsList>
                            {job.employmentType.map((type, index) => (
                              <SC.ChannelItem key={index}>{type}</SC.ChannelItem>
                            ))}
                          </SC.ChannelsList>
                        </td>
                      ) : (
                        <td>
                          <SC.NotDefinedText>Not defined</SC.NotDefinedText>
                        </td>
                      )}

                      <td>
                        <SC.StatusContainer status="ACTIVE">
                          <SC.StatusIndicator active={true} />
                          ACTIVE
                        </SC.StatusContainer>
                      </td>
                      <td>
                        {job?.information?.introduction ? (
                          <SC.IntroductionText title={job?.information?.introduction}>
                            {truncateText(job?.information?.introduction, 500)}
                          </SC.IntroductionText>
                        ) : (
                          <SC.NotSetText>No description available</SC.NotSetText>
                        )}
                      </td>
                    </>
                  ) : (
                    <>
                      {isAdmin && <td>{job.id}</td>}
                      <td>
                        <SC.JobTitle>{job.jobTitle}</SC.JobTitle>
                      </td>
                      <td>{moment(job.atsCreatedDate).format("DD.MM.YYYY")}</td>
                      <td>
                        <SC.CompanyName>{job.companyName}</SC.CompanyName>
                      </td>
                      <td>
                        <SC.JobUrl target="_blank" href={job.jobPostingUrl} rel="noreferrer">
                          {job.jobPostingUrl}
                        </SC.JobUrl>
                      </td>
                      <td>
                        <SC.LocationText>{job.locations.join(", ")}</SC.LocationText>
                      </td>
                      <td>
                        {job?.channels?.length > 0 ? (
                          <SC.ChannelsList>
                            {job.channels.map((channel, index) => (
                              <SC.ChannelItem key={index}>{channel}</SC.ChannelItem>
                            ))}
                          </SC.ChannelsList>
                        ) : (
                          <SC.NotDefinedText>Not defined</SC.NotDefinedText>
                        )}
                      </td>
                      <td>{job?.budget || "Not defined"} €</td>
                      <td>
                        <SC.StatusContainer status={job.status}>
                          <SC.StatusIndicator active={job.status === "ACTIVE"} />
                          {job.status}
                        </SC.StatusContainer>
                      </td>
                      <td>
                        <SC.JobButton
                          hasCampaignId={job.campaignId}
                          isBooked={job.booked}
                          onClick={() => {
                            if (job.campaignId) {
                              onOpenCampaignBasedOnJob(job);
                            } else {
                              onCreateCampaignBasedOnJob(job.id);
                            }
                          }}
                          disabled={campaignLoadingId === job.id}
                        >
                          {campaignLoadingId === job.id ? (
                            <SC.ButtonLoader />
                          ) : job.campaignId && job.booked ? (
                            t("Open Campaign")
                          ) : job.campaignId ? (
                            t("Open Draft Campaign")
                          ) : (
                            t("Create Campaign")
                          )}
                        </SC.JobButton>
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <SC.SkeletonRow>
                <td colSpan={hasCustomFields ? 7 : isAdmin ? 13 : 8}></td>
              </SC.SkeletonRow>
            )}
          </tbody>
        </SC.Table>
      </SC.TableContainer>
    </SC.JobsContainer>
  );
};

export default withRouter(
  withRefluxStore(
    Jobs,
    [Store__System, JobsStore],
    ["userProfile", "jobs", "loading", "campaignLoadingId"]
  )
);
